<template>
    <div>
        <el-container direction="vertical">
            <el-card shadow="never" style="margin-left: 0px;" :body-style="{ padding: '10px' }">
                <el-row style="margin-bottom: 0px;margin-top: 10px;">
                    <el-row>
                        <div>
                            <el-col :span="13">
                                <el-card style="margin: 0px 0px 10px 5px;height: 330px;">
                                    <!-- <div>风险预警</div> -->
                                    <div slot="header" class="clearfix">
                                        <span>风险预警</span>
                                    </div>
                                    <el-row>
                                        <el-table v-loading="riskListLoading" :data="riskList" height="180px" fit
                                            highlight-current-row style="width: 100%; margin-top: 0px"
                                            :show-header="false">
                                            <el-table-column width="50px" align="left">
                                                <template slot-scope="scope">
                                                    <!-- <i class="el-icon-warning risk-icon"></i> -->
                                                    <el-avatar
                                                        :style="{ backgroundColor: !scope.row.msgStatus ? 'red' : '' }"
                                                        shape="square" size="medium">{{ scope.row.refType
                                                        }}</el-avatar>
                                                </template>
                                            </el-table-column>

                                            <el-table-column min-width="300px" align="left">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.msgContent }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column width="130px" align="left">
                                                <template slot-scope="scope">
                                                    <span>{{ getParsedTime(scope.row.createTime) }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column width="50px" align="left">
                                                <template slot-scope="scope">
                                                    <el-tag v-if="scope.row.msgStatus ? false : true" size="mini"
                                                        effect="dark" type="danger">new</el-tag>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" label="操作" width="60" fixed="right">
                                                <template slot-scope="scope">
                                                    <el-button style="margin-left: 0px; align-self: center" type="text"
                                                        @click="patientWarnMessageList(scope.row)">
                                                        查看
                                                    </el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <pagination v-show="riskTotal > 0" :total="riskTotal"
                                            :page.sync="riskListQuery.page" :limit.sync="riskListQuery.pageSize"
                                            @pagination="getRiskList" :small="true" />
                                        <integrationCoDiagDialog v-if="integrationCoDiagDialogVisible"
                                            ref="integrationCoDiagDialogRef">
                                        </integrationCoDiagDialog>
                                        <patientWarnMessageDialog v-if="patientWarnMessageDialogVisible"
                                            ref="patientWarnMessageDialogRef">
                                        </patientWarnMessageDialog>
                                    </el-row>
                                </el-card>
                            </el-col>
                            <el-col :span="11">
                                <el-card style="margin: 0px 5px 10px 0px;height: 330px;">
                                    <!-- <div>业务监测</div> -->
                                    <div slot="header" class="clearfix">
                                        <span>业务监测</span>
                                        <el-radio-group v-model="businessType" size="mini"
                                            style="float: right; padding: 3px 0" @change="businessTypeChange">
                                            <el-radio-button label="全部"></el-radio-button>
                                            <el-radio-button label="协诊"></el-radio-button>
                                            <el-radio-button label="随访"></el-radio-button>
                                            <el-radio-button label="回访"></el-radio-button>
                                        </el-radio-group>
                                    </div>
                                    <el-row>
                                        <el-table v-loading="businessListLoading" :data="businessList" height="180px"
                                            fit style="width: 100%; margin-top: 0px" :show-header="false">
                                            <el-table-column width="50px" align="left">
                                                <template slot-scope="scope">
                                                    <el-avatar shape="square" size="medium">{{ scope.row.type
                                                        }}</el-avatar>
                                                </template>
                                            </el-table-column>

                                            <el-table-column align="left">
                                                <template slot-scope="scope">
                                                    <el-row>
                                                        <el-col :span="22">
                                                            <el-descriptions size="mini" class="margin-top" :column="1"
                                                                direction="vertical">
                                                                <el-descriptions-item :label="scope.row.content">{{
                                                                    getParsedTime(scope.row.createTime)
                                                                    }}</el-descriptions-item>
                                                            </el-descriptions>
                                                        </el-col>
                                                    </el-row>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" label="操作" width="60" fixed="right">
                                                <template slot-scope="scope">
                                                    <el-button style="margin-left: 0px; align-self: center" type="text"
                                                        @click="patientBusinessMonitorList(scope.row)">
                                                        查看
                                                    </el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <consultationDetailDialog v-if="consultationDetailVisiable"
                                            ref="consultationDetail">
                                        </consultationDetailDialog>
                                        <pagination v-show="businessTotal > 0" :total="businessTotal"
                                            :page.sync="businessListQuery.page" :limit.sync="businessListQuery.pageSize"
                                            @pagination="getBusinessList" :small="true" />
                                    </el-row>
                                </el-card>
                            </el-col>

                        </div>
                    </el-row>

                    <el-row>
                        <el-card class="customCard">
                            <el-row>
                                <el-col :span="4" style="margin-left: 0px;flex:1;">
                                    <el-badge :value="countCritialCodiag" class="item">
                                        <el-card class="cardColorDefault"
                                            :class="activeName === '1' && 'cardColorSkyBlue'"
                                            style="width: 200px;height: 80px;cursor: pointer;border-radius: 8px;user-select: none;"
                                            @click.native="handleTabsClick({ name: '1', type: 'click' })">
                                            <el-row style="margin-top: 10px;">
                                                <el-col :span="5">
                                                    <img src="../../assets/images/p1.png" alt="">
                                                </el-col>
                                                <el-col :span="19">
                                                    <div
                                                        style="font-size: 21px; color: #fff; font-weight: bold;margin-top: 2px;">
                                                        危急值处理
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </el-card>
                                    </el-badge>
                                </el-col>

                                <el-col :span="4" style="margin-left: 0px;flex:1;">
                                    <el-badge :value="countCodiag" class="item">
                                        <el-card class="cardColorDefault"
                                            :class="activeName === '2' && 'cardColorSkyBlue'"
                                            style="width: 200px;height: 80px;cursor: pointer;border-radius: 8px;user-select: none;"
                                            @click.native="handleTabsClick({ name: '2', type: 'click' })">
                                            <el-row style="margin-top: 10px;">
                                                <el-col :span="5">
                                                    <img src="../../assets/images/p2.png" alt="">
                                                </el-col>
                                                <el-col :span="19">
                                                    <div
                                                        style="font-size: 21px; color: #fff; font-weight: bold;margin-top: 2px;">
                                                        协诊任务
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </el-card>
                                    </el-badge>
                                </el-col>

                                <el-col :span="4" style="margin-left: 0px;flex:1;">
                                    <el-badge :value="countCodiagCallback" class="item">
                                        <el-card class="cardColorDefault"
                                            :class="activeName === '3' && 'cardColorSkyBlue'"
                                            style="width: 200px;height: 80px;cursor: pointer;border-radius: 8px;user-select: none;"
                                            @click.native="handleTabsClick({ name: '3', type: 'click' })">
                                            <el-row style="margin-top: 10px;">
                                                <el-col :span="5">
                                                    <img src="../../assets/images/p3.png" alt="">
                                                </el-col>
                                                <el-col :span="19">
                                                    <div
                                                        style="font-size: 21px; color: #fff; font-weight: bold;margin-top: 2px;">
                                                        协诊后回访
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </el-card>
                                    </el-badge>
                                </el-col>

                                <el-col :span="4" style="margin-left: 0px;flex:1;">
                                    <el-badge :value="countIntegrateService" class="item">
                                        <el-card class="cardColorDefault"
                                            :class="activeName === '4' && 'cardColorSkyBlue'"
                                            style="width: 200px;height: 80px;cursor: pointer;border-radius: 8px;user-select: none;"
                                            @click.native="handleTabsClick({ name: '4', type: 'click' })">
                                            <el-row style="margin-top: 10px;">
                                                <el-col :span="5">
                                                    <img src="../../assets/images/p4.png" alt="">
                                                </el-col>
                                                <el-col :span="19">
                                                    <div
                                                        style="font-size: 21px; color: #fff; font-weight: bold;margin-top: 2px;">
                                                        患者待管理
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </el-card>
                                    </el-badge>
                                </el-col>

                                <el-col :span="4" style="margin-left: 0px;flex:1;">
                                    <el-badge :value="countFollowup" class="item">
                                        <el-card class="cardColorDefault"
                                            :class="activeName === '5' && 'cardColorSkyBlue'"
                                            style="width: 180px;height: 80px;border-radius: 8px;cursor: pointer;user-select: none;"
                                            @click.native="handleTabsClick({ name: '5', type: 'click' })">
                                            <el-row style="margin-top: 10px;">
                                                <el-col :span="8">
                                                    <img src="../../assets/images/p5.png" alt="">
                                                </el-col>
                                                <el-col :span="16">
                                                    <div
                                                        style="font-size: 21px; color: #fff; font-weight: bold;margin-top: 2px;">
                                                        随访任务
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </el-card>
                                    </el-badge>
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-row>

                    <el-row>
                        <el-card class="elCard" style="margin: 0px 5px 10px 0px;">
                            <el-tabs v-model="activeName" @tab-click="handleClick">
                                <el-tab-pane label="危急值处理" name="1">
                                    <el-row>
                                        <el-input style="width: 220px;" v-model="listQuery1.patientName">
                                            <template slot="prepend">患者姓名</template>
                                        </el-input>
                                        <span style="margin-left: 18px;color: #909399;font-size: 14px;">病种：</span>
                                        <el-select style="width: 160px;margin-left: 0px;"
                                            v-model="listQuery1.codiagServiceName" placeholder="请选择">
                                            <el-option v-for="x in codiagServiceNameOptions" :key="x.value"
                                                :label="x.label" :value="x.value">
                                            </el-option>
                                        </el-select>
                                        <span style="margin-left: 18px;color: #909399;font-size: 14px;">来源：</span>
                                        <el-select style="width: 160px;margin-left: 0px;"
                                            v-model="listQuery1.fromSource" placeholder="请选择">
                                            <el-option v-for="x in sourceOptions" :key="x.value" :label="x.label"
                                                :value="x.value">
                                            </el-option>
                                        </el-select>
                                        <span style="margin-left: 18px;color: #909399;font-size: 14px;">科室：</span>
                                        <el-select style="width: 160px;margin-left: 0px;"
                                            v-model="listQuery1.fromSourceDeptId" filterable clearable
                                            placeholder="请选择">
                                            <el-option v-for="x in deptsOptions" :key="x.value" :label="x.label"
                                                :value="x.value">
                                            </el-option>
                                        </el-select>
                                        <span style="margin-left: 18px;color: #909399;font-size: 14px;">检测时间：</span>
                                        <el-date-picker v-model="valueData1" type="daterange" align="right"
                                            unlink-panels range-separator="至" start-placeholder="开始日期"
                                            end-placeholder="结束日期">
                                        </el-date-picker>
                                        <el-button type="primary" style="margin-left: 20px;"
                                            @click="handleTabsClick({ name: '1' })">查询</el-button>
                                    </el-row>
                                    <el-row>
                                        <el-table v-loading="listLoading" :data="list1" height="310px" border fit
                                            highlight-current-row style="width: 100%; margin-top: 20px">
                                            <el-table-column width="100px" align="center" label="测量时间">
                                                <template slot-scope="scope">
                                                    <span>{{ getParsedTime(scope.row.refTime) }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="100px" align="center" label="姓名">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.patientName }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="50px" align="center" label="性别">
                                                <template slot-scope="scope">
                                                    <span>{{ getGender(scope.row.gender) }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="50px" align="center" label="年龄">
                                                <template slot-scope="scope">
                                                    <span>{{ getAge(scope.row.birthday) }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" label="疾病标签">
                                                <template slot-scope="scope">
                                                    <span :class="scope.row.label0">糖</span>
                                                    <span :class="scope.row.label1">压</span>
                                                    <span :class="scope.row.label2">尿</span>
                                                    <span :class="scope.row.label3">脂</span>
                                                    <span :class="scope.row.label4">重</span>
                                                    <span :class="scope.row.label5">肺</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="80px" align="center" label="检测项目">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.refType }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" min-width="240px" label="数值">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.applyDiagnosis }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="120px" align="center" label="来源">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.fromSource || '-' }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="180px" align="center" label="科室">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.fromSourceDeptName || '-' }}</span>
                                                </template>
                                            </el-table-column>
                                            <!-- <el-table-column align="center" label="联系方式" min-width="120">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.phone }}</span>
                                                </template>
                                            </el-table-column> -->

                                            <!-- <el-table-column width="300px" align="center" label="诊断">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.applyDiagnosis }}</span>
                                                </template>
                                            </el-table-column> -->
                                            <el-table-column align="center" width="110px" label="任务剩余时间">
                                                <template slot-scope="scope">
                                                    <span>{{
                                                        getDetailedRemainingTime(scope.row.taskTimeoutEndTime)
                                                        }}小时</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column fixed="right" align="center" label="操作" width="180px">
                                                <template slot-scope="scope">
                                                    <el-button style="margin-left: 0px; align-self: center" type="text"
                                                        @click="patientsDetail(scope.row)">查看档案</el-button>
                                                    <el-button style="margin-left: 8px; align-self: center" type="text"
                                                        @click="codiag(scope.row)">一键协诊</el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <pagination v-show="total1 > 0" :total="total1" :page.sync="listQuery1.pageNum"
                                            :limit.sync="listQuery1.pageSize"
                                            @pagination="handleTabsClick({ name: '1' })" />
                                    </el-row>
                                </el-tab-pane>
                                <el-tab-pane label="协诊任务" name="2">
                                    <el-row>
                                        <el-input style="width: 220px;" v-model="listQuery2.patientName">
                                            <template slot="prepend">患者姓名</template>
                                        </el-input>
                                        <span style="margin-left: 18px;color: #909399;font-size: 14px;">病种：</span>
                                        <el-select style="width: 160px;margin-left: 0px;"
                                            v-model="listQuery2.codiagServiceName" placeholder="请选择">
                                            <el-option v-for="x in codiagServiceNameOptions" :key="x.value"
                                                :label="x.label" :value="x.value">
                                            </el-option>
                                        </el-select>
                                        <span style="margin-left: 18px;color: #909399;font-size: 14px;">来源：</span>
                                        <el-select style="width: 160px;margin-left: 0px;"
                                            v-model="listQuery2.fromSource" placeholder="请选择">
                                            <el-option v-for="x in sourceOptions" :key="x.value" :label="x.label"
                                                :value="x.value">
                                            </el-option>
                                        </el-select>
                                        <span style="margin-left: 18px;color: #909399;font-size: 14px;">科室：</span>
                                        <el-select style="width: 160px;margin-left: 0px;"
                                            v-model="listQuery2.fromSourceDeptId" filterable clearable
                                            placeholder="请选择">
                                            <el-option v-for="x in deptsOptions" :key="x.value" :label="x.label"
                                                :value="x.value">
                                            </el-option>
                                        </el-select>
                                        <span style="margin-left: 18px;color: #909399;font-size: 14px;">检测时间：</span>
                                        <el-date-picker v-model="valueData2" type="daterange" align="right"
                                            unlink-panels range-separator="至" start-placeholder="开始日期"
                                            end-placeholder="结束日期">
                                        </el-date-picker>
                                        <el-button type="primary" style="margin-left: 20px;"
                                            @click="handleTabsClick({ name: '2' })">查询</el-button>
                                    </el-row>
                                    <el-row>
                                        <el-table v-loading="listLoading" :data="list2" height="310px" border fit
                                            highlight-current-row style="width: 100%; margin-top: 20px">
                                            <el-table-column width="100px" align="center" label="测量时间">
                                                <template slot-scope="scope">
                                                    <span>{{ getParsedTime(scope.row.refTime) }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="100px" align="center" label="姓名">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.patientName }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="50px" align="center" label="性别">
                                                <template slot-scope="scope">
                                                    <span>{{ getGender(scope.row.gender) }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="50px" align="center" label="年龄">
                                                <template slot-scope="scope">
                                                    <span>{{ getAge(scope.row.birthday) }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" label="疾病标签">
                                                <template slot-scope="scope">
                                                    <span :class="scope.row.label0">糖</span>
                                                    <span :class="scope.row.label1">压</span>
                                                    <span :class="scope.row.label2">尿</span>
                                                    <span :class="scope.row.label3">脂</span>
                                                    <span :class="scope.row.label4">重</span>
                                                    <span :class="scope.row.label5">肺</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="80px" align="center" label="检测项目">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.refType }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" min-width="240px" label="数值">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.applyDiagnosis }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="120px" align="center" label="来源">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.fromSource || '-' }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="180px" align="center" label="科室">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.fromSourceDeptName || '-' }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" width="110px" label="任务剩余时间">
                                                <template slot-scope="scope">
                                                    <span>{{
                                                        getDetailedRemainingTime(scope.row.taskTimeoutEndTime)
                                                        }}小时</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" label="状态" min-width="90">
                                                <template slot-scope="scope">
                                                    <span>{{
                                                        scope.row.isIntegrateManage === '1' ? '已管理' :
                                                            scope.row.isIntegrateManage === '0' ? '待管理'
                                                                : '-' }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column fixed="right" align="center" label="操作" width="250">
                                                <template slot-scope="scope">
                                                    <el-button style="margin-left: 0px; align-self: center" type="text"
                                                        @click="patientsDetail(scope.row)">查看档案</el-button>
                                                    <el-button style="margin-left: 8px; align-self: center" type="text"
                                                        @click="codiag(scope.row)">一键协诊</el-button>
                                                    <!-- <el-dropdown-menu slot="dropdown">
                                                        <el-dropdown-item v-for="type in scope.row.followupTypes"
                                                            :key="type" :command="type">{{ type }}</el-dropdown-item>
                                                    </el-dropdown-menu> -->
                                                    <el-popconfirm confirm-button-text='是' cancel-button-text='否'
                                                        cancel-button-type="danger" icon="el-icon-info"
                                                        icon-color="skyblue" title="是否确认纳入管理？"
                                                        @confirm="() => { patientsIncludeManagement(scope.row); handleTabsClick({ name: '2' }) }">
                                                        <el-button slot="reference"
                                                            style="margin-left: 8px; align-self: center" type="text">
                                                            纳入管理
                                                        </el-button>
                                                    </el-popconfirm>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <pagination v-show="total2 > 0" :total="total2" :page.sync="listQuery2.pageNum"
                                            :limit.sync="listQuery2.pageSize"
                                            @pagination="handleTabsClick({ name: '2' })" />
                                    </el-row>
                                </el-tab-pane>
                                <el-tab-pane label="协诊后回访" name="3">
                                    <el-row>
                                        <el-input style="width: 300px;" v-model="listQuery1.patientName">
                                            <template slot="prepend">患者姓名</template>
                                        </el-input>
                                        <el-button type="primary" style="margin-left: 20px;"
                                            @click="handleTabsClick({ name: '3' })">查询</el-button>
                                    </el-row>
                                    <el-row>
                                        <el-table v-loading="listLoading" :data="list1" height="310px" border fit
                                            highlight-current-row style="width: 100%; margin-top: 20px">
                                            <el-table-column width="100px" align="center" label="协诊时间">
                                                <template slot-scope="scope">
                                                    <span>{{ getParsedTime(scope.row.refTime) }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="100px" align="center" label="姓名">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.patientName }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="80px" align="center" label="协诊项目">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.refType }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="80px" align="center" label="处置方式">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.codiagDealResult || '-' }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column min-width="120px" align="center" label="最迟来院时间">
                                                <template slot-scope="scope">
                                                    <span>{{ getParsedTime(scope.row.taskTimeoutEndTime) }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="100px" align="center" label="协诊医生">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.codiagDoctorName || '-' }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" width="110px" label="回访剩余时间">
                                                <template slot-scope="scope">
                                                    <span>{{
                                                        getDetailedRemainingTime(scope.row.taskTimeoutEndTime)
                                                        }}小时</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" label="联系方式" min-width="110">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.phone }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column fixed="right" align="center" label="操作" width="250">
                                                <template slot-scope="scope">
                                                    <el-button style="margin-left: 0px; align-self: center" type="text"
                                                        @click="patientsDetail(scope.row)">查看档案</el-button>
                                                    <el-button style="margin-left: 8px; align-self: center" type="text"
                                                        @click="consultationRecord(scope.row)">一键回访</el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <pagination v-show="total1 > 0" :total="total1" :page.sync="listQuery1.pageNum"
                                            :limit.sync="listQuery1.pageSize"
                                            @pagination="handleTabsClick({ name: '3' })" />
                                    </el-row>
                                </el-tab-pane>
                                <el-tab-pane label="待管理患者" name="4">
                                    <el-row>
                                        <el-input style="width: 300px;" v-model="listQuery4.name">
                                            <template slot="prepend">患者姓名</template>
                                        </el-input>
                                        <el-button type="primary" style="margin-left: 20px;"
                                            @click="handleTabsClick({ name: '4' })">查询</el-button>
                                    </el-row>
                                    <el-row>
                                        <el-table ref="multipleTable" v-loading="listLoading" :data="list4"
                                            height="310px" border fit highlight-current-row
                                            style="width: 100%; margin-top: 20px">
                                            <el-table-column align="center" label="姓名" min-width="70">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.name }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" label="性别" min-width="50">
                                                <template slot-scope="scope">
                                                    <span>{{ getGender(scope.row.gender) }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" label="年龄" min-width="50">
                                                <template slot-scope="scope">
                                                    <span>{{ getAge(scope.row.birthday) }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column width="170px" align="center" label="身份证号" min-width="180">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.idcard }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" label="疾病标签">
                                                <template slot-scope="scope">
                                                    <span :class="scope.row.label0">糖</span>
                                                    <span :class="scope.row.label1">压</span>
                                                    <span :class="scope.row.label2">尿</span>
                                                    <span :class="scope.row.label3">脂</span>
                                                    <span :class="scope.row.label4">重</span>
                                                    <span :class="scope.row.label5">肺</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" label="最后来院时间" min-width="130">
                                                <template slot-scope="scope">
                                                    <span>{{ getStandardDate(scope.row.visitTime) }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column align="center" label="联系方式" min-width="90">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.phone || '-' }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column align="center" label="状态" min-width="90">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.integrateManageStatus || '-' }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column fixed="right" align="center" label="操作" width="300">
                                                <template slot-scope="scope">

                                                    <!-- <el-button style="margin-left: 5px; align-self: center" type="text"
                                                        @click="contactRecordsList(scope.row)">
                                                        联系记录
                                                    </el-button> -->
                                                    <el-button style="margin-left: 0px; align-self: center" type="text"
                                                        @click="patientsDetail(scope.row)">查看档案</el-button>

                                                    <el-button style="margin-left: 8px; align-self: center" type="text"
                                                        @click="patientIntegrationDetail(scope.row)">
                                                        一体化方案
                                                    </el-button>

                                                    <el-popconfirm confirm-button-text='是' cancel-button-text='否'
                                                        cancel-button-type="danger" icon="el-icon-info"
                                                        icon-color="skyblue" title="是否确认纳入管理？"
                                                        @confirm="() => { patientsIncludeManagement(scope.row); handleTabsClick({ name: '4' }) }">
                                                        <el-button slot="reference"
                                                            style="margin-left: 8px; align-self: center" type="text">
                                                            纳入管理
                                                        </el-button>
                                                    </el-popconfirm>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <pagination v-show="total4 > 0" :total="total4" :page.sync="listQuery4.pageNum"
                                            :limit.sync="listQuery4.pageSize"
                                            @pagination="handleTabsClick({ name: '4' })" style="margin-top: 0px;" />
                                    </el-row>
                                </el-tab-pane>
                                <el-tab-pane label="随访任务" name="5">
                                    <el-row>
                                        <el-input style="width: 300px;" v-model="listQuery5.patientName">
                                            <template slot="prepend">患者姓名</template>
                                        </el-input>
                                        <el-button type="primary" style="margin-left: 20px;"
                                            @click="handleTabsClick({ name: '5' })">查询</el-button>
                                    </el-row>
                                    <el-row>
                                        <el-table v-loading="listLoading" :data="list5" height="310px" border fit
                                            highlight-current-row style="width: 100%; margin-top: 20px">
                                            <el-table-column width="100px" align="center" label="姓名">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.patientName }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column min-width="180" align="center" label="身份证号">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.idcard }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column width="60px" align="center" label="性别">
                                                <template slot-scope="scope">
                                                    <span>{{ getGender(scope.row.gender) }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column width="50px" align="center" label="年龄">
                                                <template slot-scope="scope">
                                                    <span>{{ getAge(scope.row.birthday) }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column align="center" label="联系方式" min-width="180">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.phone }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column fixed="right" align="center" label="操作" width="250">
                                                <template slot-scope="scope">
                                                    <el-button style="margin-left: 0px; align-self: center" type="text"
                                                        @click="patientFollowup(scope.row)">
                                                        随访
                                                    </el-button>

                                                    <el-button style="margin-left: 8px; align-self: center" type="text"
                                                        @click="patientsDetail(scope.row)">
                                                        健康档案
                                                    </el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <pagination v-show="total5 > 0" :total="total5" :page.sync="listQuery5.pageNum"
                                            :limit.sync="listQuery5.pageSize"
                                            @pagination="handleTabsClick({ name: '5' })" />
                                    </el-row>
                                </el-tab-pane>
                            </el-tabs>
                        </el-card>

                        <consultationdialog @upDataList="upDataList" v-if="consultationVisiable" ref="consultation">
                        </consultationdialog>
                        <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail>
                        <patient-integration-detail v-if="patientIntegrationDetailVisible"
                            ref="patientIntegrationDetailRef"></patient-integration-detail>
                        <annual-evaluation-detail v-if="annualEvaluationDetailVisible"
                            ref="annualEvaluationDetailRef"></annual-evaluation-detail>
                        <annualEvaluationAdd v-if="annualEvaluationAddVisible" ref="annualEvaluationAddRef">
                        </annualEvaluationAdd>

                        <codiagDiag @upDataList="handleUpdate" v-if="codiagDiagVisible" ref="codiagDiagRef">
                        </codiagDiag>
                        <blood-edit-follow-up v-if="editFollowUpVisible" ref="EditFollowUpRef"></blood-edit-follow-up>
                        <consultationRecordDialog v-if="consultationRecordVisible" ref="consultationRecordRef">
                        </consultationRecordDialog>
                        <!-- 随访 -->
                        <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail>
                        <new-follow-up v-if="newFollowUpVisible" ref="newFollowUpRef"></new-follow-up>
                    </el-row>

                </el-row>
            </el-card>

        </el-container>
    </div>
</template>

<script>
import {
    getAppDiabetSpecData,
    postMyListCodiag,
    getByIdCoDiag,
    getSearchListByLabel,
    turnToPageListByLabel,
    getSysDicList,
    getListByTime,
    getFollowupValue,
    getSearchList,
    turnToListByTime,
    addIntegrateManage,
    getDoctorListQlyyDepts
} from "@/api/health/Patients";
import {
    getMessageWorkList,
    getWarnPatientMessageWorkList,
    getBusinessMonitorList,
    updateMsgStatus,
    getBusinessHomeTips
} from "@/api/health/integrationQuery";

import moment from "moment";

import imageLine from "@/assets/images/titleLine.png";
import { time } from "echarts";

import integrationCoDiagDialog from "./integrationCoDiagDialog.vue"
import patientWarnMessageDialog from "./patientWarnMessageDialog.vue";
import Pagination from "@/components/Pagination";
import consultationdialog from "../collaborativeManagement/bloodGlucoseCollaborative/glucoseRecordDialogs/consultationdialog.vue"
import consultationDetailDialog from "../collaborativeManagement/bloodGlucoseCollaborative/glucoseRecordDialogs/consultationDetailDialog.vue"
import patientDetail from "@/views/patient/patientDetail";
import patientIntegrationDetail from "../integrationManagement/patientIntegrationDetail.vue";
import annualEvaluationDetail from "../annualEvaluation/annualEvaluationDetail.vue";
import annualEvaluationAdd from "../annualEvaluation/annualEvaluationAdd.vue";
import codiagDiag from "./codiagDiag.vue";
import bloodEditFollowUp from "../followup/bloodEditFollowUp.vue";
import consultationRecordDialog from "../collaborativeManagement/bloodGlucoseCollaborative/glucoseRecordDialogs/consultationRecordDialog.vue";
import newFollowUp from "../followup/newFollowUp.vue";

export default {
    components: {
        Pagination,
        patientDetail,
        integrationCoDiagDialog,
        patientWarnMessageDialog,
        consultationdialog,
        consultationDetailDialog,
        patientIntegrationDetail,
        annualEvaluationDetail,
        annualEvaluationAdd,
        codiagDiag,
        bloodEditFollowUp,
        consultationRecordDialog,
        newFollowUp
    },
    data() {
        return {
            activeName: '1',
            patientDetailVisible: false,
            patientIntegrationDetailVisible: false,
            integrationCoDiagDialogVisible: false,
            patientWarnMessageDialogVisible: false,
            dialogDeptTableVisible: false,
            consultationVisiable: false,
            consultationDetailVisiable: false,
            annualEvaluationDetailVisible: false,
            annualEvaluationAddVisible: false,
            codiagDiagVisible: false,
            editFollowUpVisible: false,
            allDeptDataList: null,
            allDeptDataListLoading: false,
            consultationRecordVisible: false,
            businessType: '全部',
            valueData1: null,
            valueData2: null,
            // 随访
            patientDetailVisible: false,
            newFollowUpVisible: false,
            // 危急值，协诊后回访
            list1: [],
            total1: 0,
            listQuery1: {
                idcard: null,
                patientName: null,
                fromSource: null,
                codiagServiceName: null,
                serviceName: null,
                type: null,
                isIntegrateManage: null,
                noVisitHoursStart: null,
                noVisitHoursEnd: null,
                codiagHospital: null,
                codiagStatus: null,
                codiagStartTime: null,
                codiagEndTime: null,
                codiagDealResult: null,
                fromSourceDeptId: null,
                pageNum: 1,
                pageSize: 10,
                isCritical: 1,
                taskStatus: "协诊"
            },
            //
            list2: [],
            total2: 0,
            listQuery2: {
                idcard: null,
                patientName: null,
                fromSource: null,
                codiagServiceName: null,
                serviceName: null,
                type: null,
                isIntegrateManage: null,
                noVisitHoursStart: null,
                noVisitHoursEnd: null,
                codiagHospital: null,
                codiagStatus: null,
                codiagStartTime: null,
                codiagEndTime: null,
                codiagDealResult: null,
                fromSourceDeptId: null,
                pageNum: 1,
                pageSize: 10,
                isCritical: 0,
                taskStatus: "协诊"
            },
            //
            list: [],
            total: 0,
            listLoading: false,
            listQuery: {
                name: null,
                visitTimeStart: '2020-01-01',
                visitTimeEnd: '2099-01-01',
                pageNum: 0,
                pageSize: 10,
                labels: [],
                integrateManageStatus: "已管理"
            },
            // 患者待管理
            list4: [],
            total4: 0,
            listQuery4: {
                name: null,
                visitTimeStart: '2020-01-01',
                visitTimeEnd: '2099-01-01',
                pageNum: 0,
                pageSize: 10,
                labels: [],
                integrateManageStatus: "待管理"
            },
            // 随访任务
            list5: [],
            total5: 0,
            listQuery5: {
                startTime: null,
                endTime: null,
                doctorResponse: null,
                filterExpired: null,
                isDiabetStdManage: null,
                managerHospitals: [],
                patientName: null,
                status: "未随访",
                idcard: null,
                serviceName: null,
                type: null
            },
            riskTotal: 0,
            riskListLoading: false,
            riskList: null,
            riskListQuery: {
                page: 1,
                pageSize: 10,
                isCritical: 1
            },
            businessTotal: 0,
            businessListLoading: false,
            businessList: null,
            businessListQuery: {
                type: null,
                page: 1,
                pageSize: 10
            },
            // baseFormData: null,
            medicalQualitySortVisible: false,
            medicalEffciencySortVisible: false,
            operativeIndexVisible: false,
            profitDiseaseSortVisible: false,
            hospitalizationIncomeVisible: false,
            outpatientIncomeVisible: false,
            medicalServiceDetailVisible: false,
            linkLine: imageLine,
            detail: null,
            deptTopType: "年",
            drgTopType: "智能排序",
            period: '年',
            periodMonth: null,
            periodYear: null,
            periodQuarter: null,
            periodOptions: [
                { value: "月", label: "月" },
                { value: "季", label: "季" },
                { value: "年", label: "年" }
            ],
            periodQuarterOptions: [
                { value: "1", label: "第一季度" },
                { value: "2", label: "第二季度" },
                { value: "3", label: "第三季度" },
                { value: "4", label: "第四季度" }
            ],
            deptsOptions: [],
            sexOptions: [],
            sourceOptions: [], // 指标来源
            countCritialCodiag: 0, // 危急值处理
            countCodiag: 0, // 协诊任务
            countCodiagCallback: 0, // 协诊后回访
            countIntegrateService: 0, // 患者待管理
            countFollowup: 0, // 随访
            timer: null,
            codiagServiceNameOptions: [
                { label: "全部", value: null },
                { label: "糖尿病协诊", value: "糖尿病协诊" },
                { label: "高血压协诊", value: "高血压协诊" }
            ] // 病种 
        };
    },
    created() {
        this.getSystemDictList("性别");
        this.getSourceSystemDictList("指标来源");
        this.getMasterData('depts')

        // 初始化危急值处理列表
        this.handleTabsClick({ name: "1" });

        this.getList();
        this.getRiskList();
        this.getBusinessList();
        this.getBusinessTips();
        this.startTimer();
    },
    beforeDestroy() {
        clearInterval(this.timer); // 在组件销毁前清除定时器
    },
    methods: {
        patientsIncludeManagement(row) {
            var contactParams = {
                idcard: row.idcard,
                integrateManageStatus: '已管理'
            };
            addIntegrateManage(contactParams).then(res => {
                if (res.msg == "success") {
                    console.log("已纳入管理：", res)
                    this.$message({
                        message: '已纳入管理',
                        type: 'success'
                    });
                }
            }).catch(error => {
                console.log(error);
            })
        },
        startTimer() {
            this.timer = setInterval(this.getRiskList, 30000); // 5分钟刷新一次
            console.log("风险预警刷新");
        },
        getBusinessTips() {
            getBusinessHomeTips().then(res => {
                if (res.msg == "success") {
                    var data = res.data[0];
                    this.countCritialCodiag = data.countCritialCodiag;
                    this.countCodiag = data.countCodiag;
                    this.countCodiagCallback = data.countCodiagCallback;
                    this.countIntegrateService = data.countIntegrateService;
                    this.countFollowup = data.countFollowup;
                }
            }).catch(err => {
                console.log(err);
            })
        },
        getSystemDictList(typeName) {
            var typeData = {
                "typeName": typeName
            };
            getSysDicList(typeData).then(res => {
                var records = [];
                if (res.msg == "success") {
                    var data = res.data;
                    records = data.records;
                }
                this.sexOptions = records;
            }).catch(err => {
                console.log(err);
            })
        },
        getSourceSystemDictList(typeName) {
            var typeData = {
                "typeName": typeName
            };
            getSysDicList(typeData).then(res => {
                var records = [];
                if (res.msg == "success") {
                    var data = res.data;
                    records = data.records;
                }
                this.sourceOptions = records?.map(x => ({ label: x.name, value: x.name }));
                this.sourceOptions = [{ label: "全部", value: null }, ...this.sourceOptions]
            }).catch(err => {
                console.log(err);
            })
        },
        async getMasterData(field, params) {
            try {
                if (field === 'depts') {
                    const res = await getDoctorListQlyyDepts({ isAll: "1" })
                    if (res.msg == "success") {
                        this.deptsOptions = [{ label: '全部', value: null }, ...res.data?.map(x => ({ label: x.deptName, value: x.deptId })) || []];
                    }
                }
            } catch (err) {
                console.warn(err);
            }
        },
        getRiskList() {
            // this.riskListLoading = true;
            getWarnPatientMessageWorkList(this.riskListQuery).then((res) => {
                // this.riskListLoading = false;
                if (res.msg == "success") {
                    this.riskTotal = res.data.total;
                    this.riskList = res.data.records;
                }
            }).catch(error => {
                console.log(error);
            });
        },
        businessTypeChange(type) {
            console.log("业务监测类型筛选：", type);
            if (type == '全部') {
                this.businessListQuery.type = null;

            } else {
                this.businessListQuery.type = type;
            }
            this.getBusinessList();
        },
        getBusinessList() {
            this.businessListLoading = true;
            getBusinessMonitorList(this.businessListQuery).then((res) => {
                this.businessListLoading = false;
                if (res.msg == "success") {
                    this.businessTotal = res.data.length;
                    this.businessList = res.data;
                }
            }).catch(error => {
                console.log(error);
            });
        },
        // 跳转协诊
        consultationDetail(data) {
            // this.consultationVisiable = true;

            // this.$nextTick(() => {
            //     this.$refs['consultation'].init(data);
            // })

            this.integrationCoDiagDialogVisible = true;

            this.$nextTick(() => {
                this.$refs['integrationCoDiagDialogRef'].init(this.data);
            })
        },
        //患者风险预警列表
        patientWarnMessageList(data) {
            this.updateWarnMsgStatus(data);

            this.patientWarnMessageDialogVisible = true;
            data['isLung'] = false;
            this.$nextTick(() => {
                this.$refs['patientWarnMessageDialogRef'].init(data);
            })
        },
        updateWarnMsgStatus(data) {
            if (data.msgStatus == null) {
                var query = {
                    id: data.id,
                    msgStatus: 1
                }
                updateMsgStatus(query).then((res) => {
                    if (res.msg == "success") {
                        this.getRiskList();
                    }
                }).catch(error => {
                    console.log(error);
                });
            }
        },
        //一体化方案
        patientIntegrationDetail(row) {
            this.patientIntegrationDetailVisible = true;
            this.$nextTick(() => {
                this.$refs["patientIntegrationDetailRef"].init(row);
            });
        },
        //患者业务监测列表
        patientBusinessMonitorList(data, scope) {
            if (data.type == "协诊") {
                this.consultation(data);
            } else if (data.type == "随访") {
                //随访
                this.getPatientInfo(data);
            } else if (data.type == "回访") {
                //回访
                this.consultationRecord(data);
            }
        },
        //处置回访
        consultationRecord(data) {
            this.consultationRecordVisible = true;
            this.$nextTick(() => {
                this.$refs.consultationRecordRef.init(data);
            });
        },
        onEditFollowUp(row) {

            console.log('编辑该条随访详情：', row);

            // row["pInfo"] = this.getPatientInfo(row);

            let params = {
                idcard: row.idcard,
                paramNames: ['空腹血糖']
            }
            var data = {
                idcard: row.idcard,
                status: "已完成"
            }

            if (row.status == "已完成") {
                getPatientFollowupRecord(params)
                    .then((res) => {
                        if (res.msg == "success") {
                            row["records"] = res.data;
                            getFollowupValue(params).then((response) => {
                                if (response.msg == "success") {
                                    // if (response.data.length > 0) {
                                    if (response.data.length > 0) {
                                        var resData = response.data[0];
                                        row.bloodSuger = resData.paramValue;
                                        row.nextFollowupTime = resData.nextFollowupTime;
                                        row.bloodsugarTime = resData.checkTime;
                                    }
                                    this.editFollowUpVisible = true;
                                    this.$nextTick(() => {
                                        this.$refs.EditFollowUpRef.init(row);
                                    });
                                    // } else {
                                    //     this.$message({
                                    //         message: "该患者暂无血糖值，请获取最新血糖值！",
                                    //         type: "error",
                                    //     });
                                    // }
                                }
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else {
                getListByTime(data).then((res) => {
                    if (res.msg == "success") {
                        row["records"] = res.data.records[0];
                        getFollowupValue(params).then((response) => {
                            if (response.msg == "success") {
                                // if (response.data.length > 0) {
                                if (response.data.length > 0) {
                                    var resData = response.data[0];
                                    row.bloodSuger = resData.paramValue;
                                    row.nextFollowupTime = resData.nextFollowupTime;
                                    row.bloodsugarTime = resData.checkTime;
                                    row.serviceName = row.content;
                                }
                                this.editFollowUpVisible = true;
                                this.$nextTick(() => {
                                    this.$refs.EditFollowUpRef.init(row);
                                });
                                // } else {
                                //     this.$message({
                                //         message: "该患者暂无血糖值，请获取最新血糖值！",
                                //         type: "error",
                                //     });
                                // }
                            }
                        });
                    }
                });
            }
        },
        getPatientInfo(row) {
            var query = {
                idcard: row.idcard
            }
            getSearchList(query).then((res) => {
                if (res.msg == "success") {
                    if (res.data.records.length > 0) {
                        var baseFormData = res.data.records[0];
                        row["pInfo"] = baseFormData;
                        console.log('baseFormData:', baseFormData);
                        this.onEditFollowUp(row);
                    } else {
                        this.onEditFollowUp(row);
                    }
                } else {
                    this.onEditFollowUp(row);
                }
            });
        },
        // 跳转协诊记录表
        consultation(data) {

            this.codiagDiagVisible = true;

            console.log('一键协诊：', data);

            const params = {
                id: data.refId
            }
            getByIdCoDiag(params).then(res => {
                if (res.msg == "success") {
                    data = res.data;
                    this.$nextTick(() => {
                        this.$refs['codiagDiagRef'].init(data);
                    })
                }
            })
        },
        //年度评估
        patientsAnnualEvaluation(row) {
            this.annualEvaluationAddVisible = true;
            this.$nextTick(() => {
                this.$refs["annualEvaluationAddRef"].init(row);
            });
        },
        //管理队列 协诊完成之后刷新列表
        upDataList() {
            // this.getBusinessList();
            this.getList();
        },
        handleTabsClick(props) {
            const { name, type, ...otherParams } = props;
            if (type === 'click') {
                this.listQuery1.pageNum = 1;
                this.listQuery1.patientName = null;
            }
            if (name === '1') {
                // console.warn('危急值处理')
                this.activeName = name;
                if (!this.listQuery1.fromSourceDeptId) {
                    this.listQuery1.fromSourceDeptId = null;
                }
                this.getList1({
                    isCritical: 1,
                    taskStatus: "协诊",
                    refStartTime: this.valueData1 ? this.getParseDate(this.valueData1[0], 1) : null,
                    refEndTime: this.valueData1 ? this.getParseDate(this.valueData1[1], 2) : null,
                    ...otherParams
                });
            }
            if (name === '2') {
                // console.warn('协诊任务')
                this.activeName = name;
                if (!this.listQuery2.fromSourceDeptId) {
                    this.listQuery2.fromSourceDeptId = null;
                }
                const requestParams = {
                    isCritical: 0,
                    taskStatus: "协诊",
                    refStartTime: this.valueData2 ? this.getParseDate(this.valueData2[0], 1) : null,
                    refEndTime: this.valueData2 ? this.getParseDate(this.valueData2[1], 2) : null,
                    ...otherParams
                };
                console.log('协诊任务参数:', requestParams, 'listQuery2:', this.listQuery2);
                this.getList2(requestParams);
            }
            if (name === '3') {
                // console.warn('协诊后回访')
                this.activeName = name;
                this.getList1({ isCritical: undefined, taskStatus: "回访", fromSource: null, fromSourceDeptId: null, ...params });
            }
            if (name === '4') {
                // console.warn('患者待管理')
                this.activeName = name;
                this.getList4();
            }
            if (name === '5') {
                // console.warn('随访任务')
                this.activeName = name;
                this.getList5();
            }
        },
        // 一键协诊后，刷新列表
        handleUpdate() {
            this.handleTabsClick({ name: this.activeName })
        },
        handleClick(tab, event) { },
        getList1(props) {
            this.listLoading = true;
            postMyListCodiag({ ...this.listQuery1, ...props }).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.list1 = res.data.records;
                    this.total1 = res.data.total;
                    this.list1.forEach((item, index) => {
                        this.list1[index].label0 = this.setLabel0(item)
                            ? this.setLabel0(item)
                            : "labelNone";
                        this.list1[index].label1 = this.setLabel1(item)
                            ? this.setLabel1(item)
                            : "labelNone";
                        this.list1[index].label2 = this.setLabel2(item)
                            ? this.setLabel2(item)
                            : "labelNone";
                        this.list1[index].label3 = this.setLabel3(item)
                            ? this.setLabel3(item)
                            : "labelNone";
                        this.list1[index].label4 = this.setLabel4(item)
                            ? this.setLabel4(item)
                            : "labelNone";
                        this.list1[index].label5 = this.setLabel5(item)
                            ? this.setLabel5(item)
                            : "labelNone";
                    });
                }
            });
        },
        getList2(props) {
            this.listLoading = true;
            const requestData = { ...this.listQuery2, ...props };
            console.log('getList2 请求参数:', requestData);
            console.log('requestData.isCritical:', requestData.isCritical);
            postMyListCodiag(requestData).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.list2 = res.data.records;
                    this.total2 = res.data.total;
                    this.list2.forEach((item, index) => {
                        this.list1[index].label0 = this.setLabel0(item)
                            ? this.setLabel0(item)
                            : "labelNone";
                        this.list1[index].label1 = this.setLabel1(item)
                            ? this.setLabel1(item)
                            : "labelNone";
                        this.list1[index].label2 = this.setLabel2(item)
                            ? this.setLabel2(item)
                            : "labelNone";
                        this.list1[index].label3 = this.setLabel3(item)
                            ? this.setLabel3(item)
                            : "labelNone";
                        this.list1[index].label4 = this.setLabel4(item)
                            ? this.setLabel4(item)
                            : "labelNone";
                        this.list1[index].label5 = this.setLabel5(item)
                            ? this.setLabel5(item)
                            : "labelNone";
                    });
                }
            });
        },
        // 已管理
        getList() {
            this.listLoading = true;

            if (this.doctorName == "韩明宏") {
                var limitLabels = ["lungcancer", "lungcancer_danger_nodule", "lungcancer_danger_mass", "lungcancer_danger_tumor"];
                this.listQuery.limitLabels = limitLabels;
            }

            this.listQuery.mobileExist = null;

            getSearchListByLabel(this.listQuery).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.list = res.data.records;
                    this.total = res.data.total;
                    this.list.forEach((item, index) => {
                        this.list[index].label0 = this.setLabel0(item)
                            ? this.setLabel0(item)
                            : "labelNone";
                        this.list[index].label1 = this.setLabel1(item)
                            ? this.setLabel1(item)
                            : "labelNone";
                        this.list[index].label2 = this.setLabel2(item)
                            ? this.setLabel2(item)
                            : "labelNone";
                        this.list[index].label3 = this.setLabel3(item)
                            ? this.setLabel3(item)
                            : "labelNone";
                        this.list[index].label4 = this.setLabel4(item)
                            ? this.setLabel4(item)
                            : "labelNone";
                        this.list[index].label5 = this.setLabel5(item)
                            ? this.setLabel5(item)
                            : "labelNone";
                        //followupTypes,根据标签得出支持的随访类型
                        this.list[index].followupTypes = this.setFollowupTypes(item)
                    });
                }
            });
        },
        // 待管理
        getList4() {
            this.listLoading = true;

            if (this.doctorName == "韩明宏") {
                var limitLabels = ["lungcancer", "lungcancer_danger_nodule", "lungcancer_danger_mass", "lungcancer_danger_tumor"];
                this.listQuery4.limitLabels = limitLabels;
            }

            this.listQuery4.mobileExist = null;

            getSearchListByLabel(this.listQuery4).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.list4 = res.data.records;
                    this.total4 = res.data.total;
                    this.list4.forEach((item, index) => {
                        this.list4[index].label0 = this.setLabel0(item)
                            ? this.setLabel0(item)
                            : "labelNone";
                        this.list4[index].label1 = this.setLabel1(item)
                            ? this.setLabel1(item)
                            : "labelNone";
                        this.list4[index].label2 = this.setLabel2(item)
                            ? this.setLabel2(item)
                            : "labelNone";
                        this.list4[index].label3 = this.setLabel3(item)
                            ? this.setLabel3(item)
                            : "labelNone";
                        this.list4[index].label4 = this.setLabel4(item)
                            ? this.setLabel4(item)
                            : "labelNone";
                        this.list4[index].label5 = this.setLabel5(item)
                            ? this.setLabel5(item)
                            : "labelNone";
                    });
                }
            });
        },
        // 随访任务
        getList5() {
            this.listLoading = true;
            turnToListByTime({ ...this.listQuery5 }).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.list5 = res.data.records;
                    this.total5 = res.data.total;
                    this.list5.forEach((item, index) => {
                        this.list5[index].label0 = this.setLabel0(item)
                            ? this.setLabel0(item)
                            : "labelNone";
                        this.list5[index].label1 = this.setLabel1(item)
                            ? this.setLabel1(item)
                            : "labelNone";
                        this.list5[index].label2 = this.setLabel2(item)
                            ? this.setLabel2(item)
                            : "labelNone";
                        this.list5[index].label3 = this.setLabel3(item)
                            ? this.setLabel3(item)
                            : "labelNone";
                        this.list5[index].label4 = this.setLabel4(item)
                            ? this.setLabel4(item)
                            : "labelNone";
                        this.list5[index].label5 = this.setLabel5(item)
                            ? this.setLabel5(item)
                            : "labelNone";
                    });
                }
            });
        },
        //随访
        patientFollowup(row) {
            this.newFollowUpVisible = true;
            this.$nextTick(() => {
                this.$refs["newFollowUpRef"].init(row);
            });
        },
        // 跳转至相应病人档案详情页
        patientsDetail(row) {
            this.patientDetailVisible = true;
            this.$nextTick(() => {
                this.$refs["PatientDetailRef"].init(row);
            });
        },
        //一键协诊
        codiag(rowValue) {
            this.codiagDiagVisible = true;

            this.$nextTick(() => {
                this.$refs['codiagDiagRef'].init(rowValue);
            })
        },
        // 导航跳转查询列表页
        turnToPage4() {
            this.listLoading = true;
            turnToPageListByLabel(this.listQuery4).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.list4 = res.data.records;
                    this.total4 = res.data.total;
                    this.list4.forEach((item, index) => {
                        this.list4[index].label0 = this.setLabel0(item)
                            ? this.setLabel0(item)
                            : "labelNone";
                        this.list4[index].label1 = this.setLabel1(item)
                            ? this.setLabel1(item)
                            : "labelNone";
                        this.list4[index].label2 = this.setLabel2(item)
                            ? this.setLabel2(item)
                            : "labelNone";
                        this.list4[index].label3 = this.setLabel3(item)
                            ? this.setLabel3(item)
                            : "labelNone";
                        this.list4[index].label4 = this.setLabel4(item)
                            ? this.setLabel4(item)
                            : "labelNone";
                        this.list4[index].label5 = this.setLabel5(item)
                            ? this.setLabel5(item)
                            : "labelNone";
                    });
                }
            });
        },
        //联系记录
        contactRecordsList() {

        },
        //同意并纳入管理
        agreeIncludeManagement() {

        },
        /** 糖尿病 */
        setLabel0(item) {
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded = labels.some(dt => dt.label === "diabet");
                const isIncluded2 = labels.some(dt => dt.label === "diabet_danger");
                const isIncluded3 = labels.some(dt => dt.label === "easy_diabet");

                if (isIncluded) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        /** 高血压 */
        setLabel1(item) {
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded = labels.some(dt => dt.label === "hyper");
                const isIncluded2 = labels.some(dt => dt.label === "hyper_danger");
                const isIncluded3 = labels.some(dt => dt.label === "easy_hyper");

                if (isIncluded) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        /** 高尿酸 */
        setLabel2(item) {
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded = labels.some(dt => dt.label === "hyperuricemia");
                const isIncluded2 = labels.some(dt => dt.label === "hyperuricemia_danger");
                const isIncluded3 = labels.some(dt => dt.label === "easy_hyperuricemia");

                if (isIncluded) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        /** 高血脂 */
        setLabel3(item) {
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded = labels.some(dt => dt.label === "bloodfat");
                const isIncluded2 = labels.some(dt => dt.label === "bloodfat_danger");

                if (isIncluded) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        /** 高体重 */
        setLabel4(item) {
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded = labels.some(dt => dt.label === "overweight");

                if (isIncluded) {
                    return "labelRed"
                }
            } else {
                return "labelNone";
            }
        },
        /** 慢阻肺 肺癌管理 */
        setLabel5(item) {
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded = labels.some(dt => dt.label === "lungcancer");
                const isIncluded2 = labels.some(dt => dt.label === "lungcancer_danger_nodule" || dt.label === "lungcancer_danger_mass" || dt.label === "lungcancer_danger_tumor");
                const isIncluded3 = labels.some(dt => dt.label === "easy_lungcancer");

                if (isIncluded) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        setFollowupTypes(item) {
            var labels = item.labels;
            var followupTypes = [];
            if (labels != null && labels.length > 0) {

                var isIncluded = labels.some(dt => dt.label === "diabet" || dt.label === "diabet_danger");
                if (isIncluded) followupTypes.push("糖尿病随访");

                isIncluded = labels.some(dt => dt.label === "hyper" || dt.label === "hyper_danger");
                if (isIncluded) followupTypes.push("高血压随访");

                isIncluded = labels.some(dt => dt.label === "bloodfat" || dt.label === "bloodfat_danger");
                if (isIncluded) followupTypes.push("高血脂随访");
            }
            return followupTypes;
        },
        getItemDetail() {

        },
        exportList() { },
        getGender(gender) {
            var option = this.sexOptions.filter(v => v.value == gender)[0];
            return option.name;
        },
        // 计算当前年龄
        getAge(birthday) {
            if (birthday == null) return "";

            var birthdays = new Date(birthday.replace(/-/g, "/"));
            let d = new Date();
            let age =
                d.getFullYear() -
                birthdays.getFullYear() -
                (d.getMonth() < birthdays.getMonth() ||
                    (d.getMonth() == birthdays.getMonth() &&
                        d.getDate() < birthdays.getDate())
                    ? 1
                    : 0);
            return age;
        },
        // 日期格式转化
        getParseDate(time, type) {
            if (type == 1) {
                var newTime = new Date(time);
            } else if (type == 2) {
                var newTime = new Date((new Date(time) / 1000 + 86400) * 1000);
            }
            // 获取完整的年份(4位)
            var year = newTime.getFullYear();
            // 获取月份(0-11,0代表1月)
            var month = newTime.getMonth() + 1;
            // 获取日期(1-31)
            var date = newTime.getDate();

            return (
                year +
                "-" +
                (month < 10 ? "0" + month : month) +
                "-" +
                (date < 10 ? "0" + date : date)
            );
        },
        getParsedTime(time) {
            if (!time) {
                return '-'
            }
            return moment(time).format("YYYY-MM-DD HH:mm");
        },
        getStandardDate(dateString) {
            const formattedDate = moment(dateString).format('YYYY-MM-DD HH:mm');
            return formattedDate;
        },
        getDetailedRemainingTime(time) {
            if (!time) {
                return '0'
            }

            const now = moment();
            const endTime = moment(time);

            // 计算时间差（毫秒）
            const diffMs = endTime.diff(now);

            // 如果已过期
            if (diffMs <= 0) {
                return '0';
            }

            // 转换为小时并保留1位小数
            const remainingHours = diffMs / (1000 * 60 * 60);
            return `${remainingHours.toFixed(0) || 0}`;
        }
    },
};
</script>

<style>
.box-card {
    width: 1443px;
}

.elCard .el-tabs__header {
    display: none !important;
}

.customCard {
    margin: 0px 5px 10px 0px;
    padding-bottom: 10px;
}

.customCard .el-row {
    display: flex;
    gap: 6px;
}

.customCard .el-card__body {
    padding: 10px;
}

.card-panel-col {
    display: flex;
    flex-direction: row;
    margin-left: 10px;
}

.card-panel-icon-wrapper {
    display: flex;
    width: 60px;
    height: 60px;
    flex-direction: column;
    justify-content: center;
    /* 水平居中*/
    align-items: center;
    margin-bottom: 10px;
}

.image {
    width: 50px;
    height: 50px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: none;
}

.cardImage1 {
    width: 60px;
    height: 60px;
}

.cardImage2 {
    width: 65px;
    height: 65px;
}

.card-panel-icon-wrapper2 {
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    /* 水平居中*/
    align-items: center;
    margin-bottom: 10px;
}

.image2 {
    width: 50px;
    height: 50px;
    margin-left: 10px;
    display: flex;
    justify-content: center;
    /* 水平居中*/
    align-items: center;
}

.cardColorBlue {
    background: linear-gradient(to right, #9fccfc, #618bff);
}

.cardColorPurple {
    background: linear-gradient(to right, #a4aefc, #6089ff);
}

.cardColorGreen {
    background: linear-gradient(to right, #9ad2e7, #74bfdc);
}

.cardColorSkyBlue {
    background: linear-gradient(-89.83deg, rgba(122, 184, 251, 1) 1.16%, rgba(145, 213, 255, 0.5) 99.16%) !important;
}

.cardColorDefault {
    background: linear-gradient(-89.83deg, rgba(187, 187, 187, 0.74) 1.16%, rgba(187, 187, 187, 1) 99.16%);
}

.el-progress-bar__inner {
    background-color: unset;
    background-image: linear-gradient(to right, #6855ff, #5aa2eb);
}

.item {
    margin-top: 10px;
    margin-right: 40px;
}

.custom-icon {
    font-size: 36px;
    color: #fff;
    opacity: 0.75;
}

.risk-icon {
    font-size: 24px;
    color: red;
    opacity: 0.75;
    display: flex;
    align-items: center;
    margin-top: 10px;
}


.labelRed {
    height: 24px;
    width: 24px;
    border-radius: 50%;
    color: white;
    background: red;
    display: inline-block;
    /* padding: 3px; */
}

.labelRedCircle {
    height: 22px;
    width: 22px;
    border-radius: 50%;
    border: 1px solid red;
    background: #fff;
    color: red;
    display: inline-block;
    /* padding: 2px; */
}

.labelBlue {
    border-radius: 50%;
    color: white;
    background: blue;
    padding: 3px;
}

.labelOrange {
    border-radius: 50%;
    color: white;
    background: orange;
    padding: 3px;
}

.labelGreen {
    border-radius: 50%;
    color: white;
    background: green;
    padding: 3px;
}

.labelGray {
    border-radius: 50%;
    color: white;
    background: gray;
    padding: 3px;
}

.labelPurple {
    border: 1px solid purple;
    background: purple;
    color: #fff;
    padding: 2px;
    border-radius: 50%;
}

.labelNone {
    display: none;
}
</style>